/* eslint-disable */
import listing from "@/apollo/cruises/inventory/listing.gql";
import create_update from "@/apollo/cruises/inventory/create.gql";
import edit_by_id from "@/apollo/cruises/inventory/edit_by_id.gql";
import by_routes from "@/apollo/cruises/inventory/by_routes.gql";
import enable_disable from "@/apollo/cruises/inventory/enable_disable.gql";
import hold_book_inventory from "@/apollo/cruises/hold_book_inventory.gql";
import fetch_for_context from "@/apollo/cruises/fetch_for_context.gql";

export const state = () => ({
  list: [],
  loading: false,
  creating: false
});

export const mutations = {
  /**
   * @description
   * @author Saurabh Jangra
   * @date 25 Jan 2025 | 04:10PM
   * @param {*} state
   * @param {*} value
   */
  setListing: (state, value) => (state.list = value),
  /**
   * @description
   * @author Saurabh Jangra
   * @date 25 Jan 2025 | 04:10PM
   * @param {*} state
   * @param {*} value
   */
  setLoading: (state, value) => (state.loading = value),
  /**
   * @description
   * @author Saurabh Jangra
   * @date 25 Jan 2025 | 04:10PM
   * @param {*} state
   * @param {*} value
   */
  setCreating: (state, value) => (state.creating = value)
};

export const actions = {
  /**
   * @description
   * @author Saurabh Jangra
   * @date 25 Jan 2025 | 04:09PM
   * @param {*} { commit }
   * @param {*} search_by
   * @returns {*}
   */
  fetchListing({ commit }, search_by) {
    commit("setLoading", true);
    commit("setListing", []);
    return new Promise((resolve) => {
      this.$apolloClient
        .query({ query: listing, variables: { search_by } })
        .then(({ data }) => {
          commit("setListing", data.cruise_fetch_inventories);
          resolve(data.cruise_fetch_inventories);
          commit("setLoading", false);
        })
        .catch((err) => {
          commit("setLoading", false);
        });
    });
  },
  /**
   * @description
   * @author Saurabh Jangra
   * @date 25 Jan 2025 | 04:09PM
   * @param {*} { commit }
   * @param {*} payload
   * @returns {*}
   */
  create({ commit }, payload) {
    commit("setCreating", true);
    return new Promise((resolve) => {
      this.$apolloClient
        .mutate({ mutation: create_update, variables: { payload } })
        .then(({ data }) => {
          resolve(data.create_cruise_inventory);
          commit("setCreating", false);
        })
        .catch((err) => {
          commit("setCreating", false);
        });
    });
  },
  /**
   * @description
   * @author Saurabh Jangra
   * @date 22 Feb 2025 | 03:21PM
   * @param {*} __
   * @param {*} inventory_id
   * @returns {*}
   */
  enable_disable(__, inventory_id) {
    return new Promise((resolve) => {
      this.$apolloClient.mutate({ mutation: enable_disable, variables: { inventory_id } }).then(({ data }) => {
        resolve(data.enable_disable_cruise_inventory);
      });
    });
  },
  /**
   * @description
   * @author Saurabh Jangra
   * @date 25 Jan 2025 | 04:09PM
   * @param {*} _
   * @param {*} _id
   * @returns {*}
   */
  by_id(_, _id) {
    return new Promise((resolve) => {
      this.$apolloClient.query({ query: edit_by_id, variables: { _id } }).then(({ data }) => {
        resolve(data.fetch_cruise_inventory_by_id);
      });
    });
  },
  /**
   * @description
   * @author Saurabh Jangra
   * @date 06 Feb 2025 | 11:02AM
   * @param {*} __
   * @param {*} _id
   * @returns {*}
   */
  by_routes(__, _id) {
    return new Promise((resolve) => {
      this.$apolloClient.query({ query: by_routes, variables: { _id } }).then(({ data }) => {
        resolve(data.cruise_inventory_by_route);
      });
    });
  },
  /**
   * @description
   * @author Saurabh Jangra
   * @date 27 Feb 2025 | 12:47PM
   * @param {*} __
   * @param {*} payload
   * @returns {*}
   */
  fetch_context_details(__, payload) {
    return new Promise(async (resolve) => {
      try {
        const {
          data: { fetch_cruise_for_context }
        } = await this.$apolloClient.query({ query: fetch_for_context, variables: { payload } });
        resolve(fetch_cruise_for_context);
      } catch (error) {}
    });
  },
  /**
   * @description
   * @author Saurabh Jangra
   * @date 26 Feb 2025 | 12:05PM
   * @param {*} __
   * @param {*} payload
   * @returns {*}
   */
  hold(__, payload) {
    return new Promise(async (resolve) => {
      try {
        const {
          data: { hold_book_cruise_inventory }
        } = await this.$apolloClient.mutate({ mutation: hold_book_inventory, variables: { payload } });
        resolve(hold_book_cruise_inventory);
      } catch (error) {}
    });
  },
  /**
   * @description
   * @author Saurabh Jangra
   * @date 04 Mar 2025 | 03:10PM
   * @param {*} { commit }
   * @param {*} search_by
   * @returns {*}
   */
  refresh({ commit }, search_by) {
    return new Promise(async (resolve) => {
      const _result = this.$subscribeClient.iterate({
        query: `subscription { refresh_cruise_inventory_listing }`
      });
      for await (const event of _result) {
        this.$apolloClient.query({ query: listing, variables: { search_by } }).then(({ data }) => {
          commit("setListing", data.cruise_fetch_inventories);
          resolve(data.cruise_fetch_inventories);
        });
      }
    });
  }
};

export const getters = {
  list: (state) => state.list,
  loading: (state) => state.loading,
  creating: (state) => state.creating
};
